module.exports = __webpack_public_path__ + "img/purse.0e25c157.svg";